module.exports = __webpack_public_path__ + "img/20260225.4fb237c0.png";